import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'countdown-dialog-component',
    styleUrls: ['countdown.dialogcomponent.css'],
    templateUrl: 'countdown.dialogcomponent.html'
})
export class CountdownDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;
    canceltext: string;

    curtime: number;
    maxtime: number;
    time: number;
    timerHandle: number;
    timeStr: string;

    constructor(public dialogRef: MatDialogRef<CountdownDialogComponent>, @Inject(MAT_DIALOG_DATA) public data : _CountdownDialogOptions) {
        this.title = data.TitleText || 'Please wait...';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || '';
        this.canceltext = data.CancelText || '';
        this.maxtime = data.CountdownTime || 170;
        this.curtime = this.maxtime;
    }

    CancelHandler() {
        // Disable timer, if possible
        if (this.timerHandle) window.clearTimeout(this.timerHandle);

        this.dialogRef.close(null);
    }

    private GetTimeString(timeval: number) {
        let result = Math.floor(timeval / 60) + ':' + ('00' + Math.floor(timeval % 60)).slice(-2);

        return result;
    }

    ngOnInit() {
        this.time = 100;
        this.timerHandle = null;
        this.timeStr = '';

        // Initialize ticking to get it rolling
        this.Tick();
    }

    OKHandler() {
        // Disable timer, if possible
        if (this.timerHandle) window.clearTimeout(this.timerHandle);

        this.dialogRef.close(true);
    }

    private Tick() {
        this.curtime--;
        if (this.curtime > 0) {
            this.time = Math.floor(this.curtime * 100 / this.maxtime);
            this.timeStr = this.GetTimeString(this.curtime);

            this.timerHandle = window.setTimeout(() => {
                this.Tick();
            }, 1000);
        } else {
            // Close the dialog automatically as a "cancel"
            this.CancelHandler();
        }
    }
}

export class _CountdownDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    CountdownTime?: number;
}


// WEBPACK FOOTER //
// ./src/services/dialogs/countdown/countdown.dialogcomponent.ts